"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactMotion = require("react-motion");
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _startListTable = _interopRequireDefault(require("./start-list-table"));
var _timingTeamExport = _interopRequireDefault(require("./timing-team-export"));
var _pdfDownload = _interopRequireDefault(require("./pdf-download"));
var _pdfRunningOrder = _interopRequireDefault(require("./pdf-runningOrder"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import DisplayRefCodes from 'core/display-ref-codes';

// the styled h2 and div are purely to improve the layout of the printed version of the start list
const H2 = _styledComponents.default.h2`
  @media print {
    font-size: 1em;
    line-height: 1.1em;
    margin-bottom: 0px;
    page-break-after: avoid;
  }
`;
const HtmlText = _styledComponents.default.div`
  @media print {
    font-size: 0.7em;
    page-break-after: always;
  }
`;
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Start List is not available yet");
var _ref3 = /*#__PURE__*/_react.default.createElement("h2", {
  className: "hidden-print"
}, "Start List");
var _ref4 = /*#__PURE__*/_react.default.createElement("br", null);
class StartList extends _react.Component {
  constructor(...args) {
    super(...args);
    /**
     * Get a list of all rtc codes that are in use for the given day
    _getRtcCodes(day) {
      const rtcCodes = [];
      day.dayRaceOrders.forEach(race => {
        race.completedEntries.forEach(entry => {
          entry.rtcRefs.forEach(ref => {
            if (rtcCodes.indexOf(ref) === -1) {
              rtcCodes.push(ref);
            }
          });
        });
      });
      return rtcCodes;
    },
    */
    _defineProperty(this, "_onPrint", () => {
      window.print();
      return false;
    });
  }
  render() {
    if (!this.props.loaded) return _ref;
    const competition = this.props.competition;
    const competitionDays = competition.competitionDays.filter(d => d.startListRuns.length && d.phases.length); // ignore days with no runs

    if (!competition.isAdministratedByUser && !competition.displayStartList && !(competition.displayStartListNotes && competition.startListNotes)) return _ref2;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-sm-right hidden-print"
    }, /*#__PURE__*/_react.default.createElement(_pdfDownload.default, {
      competitionDays: !competition.displayStartList && !competition.isAdministratedByUser ? null : competitionDays,
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID,
      displayStartListNotes: !!competition.startListNotes
    }), /*#__PURE__*/_react.default.createElement(_pdfRunningOrder.default, {
      competitionDays: !competition.displayStartList && !competition.isAdministratedByUser ? null : competitionDays,
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID
    })), _ref3, _ref4, !competition.isAdministratedByUser && !(competition.displayStartListNotes && competition.startListNotes) ? null : /*#__PURE__*/_react.default.createElement(HtmlText, {
      dangerouslySetInnerHTML: competition.startListNotes
    }), !competition.isAdministratedByUser && !(competition.displayStartList && competitionDays.length) ? null : /*#__PURE__*/_react.default.createElement("div", null, competitionDays.map(day => /*#__PURE__*/_react.default.createElement("div", {
      key: day.id
    }, /*#__PURE__*/_react.default.createElement(H2, {
      className: "text-primary"
    }, (0, _occasion.default)(day.dayDate, 'dddd')), /*#__PURE__*/_react.default.createElement(_startListTable.default, {
      displayFreeCode: competition.displayFreeCode,
      startListRuns: day.startListRuns,
      phases: day.phases
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "hidden-print"
    }, /*#__PURE__*/_react.default.createElement(_timingTeamExport.default, {
      competitionDays: competitionDays
    }))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = {
  id: true,
  competitionName: true,
  displayStartList: true,
  displayStartListNotes: true,
  startListNotes: true,
  clubID: true,
  isAdministratedByUser: true,
  displayFreeCode: true,
  competitionDays: {
    id: true,
    dayDate: true,
    phases: {
      refCode: true,
      description: true
    },
    startListRuns: {
      id: true,
      phaseRef: true,
      phaseDescription: true,
      competitionDayID: true,
      raceID: true,
      fixedStartTime: true,
      secsAfterPhase: true,
      secsBetweenPaddlers: true,
      runSplitNumber: true,
      splitPercentage: true,
      numberOfHoldingPlaces: true,
      onlyUseHoldingPlaces: true,
      race: {
        raceName: true,
        eventDescription: true,
        competitionDivision: {
          id: true,
          description: true,
          isRanking: true
        }
      },
      startListEntries: {
        id: true,
        startListBib: true,
        bibNumber: true,
        bibName: true,
        ageCategoryDescription: true,
        entryText: true,
        clubName: true,
        rtcRefs: true,
        freeCode: true,
        classDivision: {
          classDescription: true,
          rankingDivisionDescription: true
        },
        isSelectionPaddler: true
      }
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(StartList, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref5
}));